<cb-council-rfi-list
    *cbWaitFor="lotMappedItem$$ | async"
    [hidden]="!!councilRfiViewService.councilRfi"
    [lotMappedItem]="lotMappedItem"
></cb-council-rfi-list>
@if (councilRfiViewService.councilRfi) {
    <cb-manage-council-rfi></cb-manage-council-rfi>
}
